module.exports = __webpack_public_path__ + "img/theme13.cd3f3fe8.png";